module.exports = __webpack_public_path__ + "static/img/son1.2a505351.png";